<template>
  <main id="content" aria-labelledby="main-title" v-if="page">
    <ElementHero v-if="page?.hero" :content="page?.hero" />
    <template v-if="page?.dynamic">
      <template v-for="(section, index) in page?.dynamic">
        <component 
        :is="getSectionComponent(section.collection)" 
        :sectionIndex="index" 
        :content="section.item" 
        :sectionTotal="page.dynamic.length"
        />
      </template>
    </template>
    <ElementBookDemoCta />
  </main>
</template>

<script setup>
// Publish gate: an unbuilt CMS page 404s until the next deploy prerenders it.
useRequirePrerendered()

const route = useRoute()
const contentSections = useContentSections()
const { getItems } = useCms()
const fields = useFields()

const currentLocale = computed(() => {
  return route.path.startsWith('/nz') ? 'nz' : 'au'
})

const { data } = await useAsyncData(
  // Reactive key: refetches on slug/locale change without a full page remount, so we
  // can drop the global page-key remount (see specs/remove-global-page-key.md).
  () => `${currentLocale.value}-solutions-${route.params.slug}`,
  () => getItems({
    collection: 'page',
    params: {
      filter: {
        locale: { _contains: currentLocale.value },
        slug: {
          "_eq": route.params.slug
        },
        status: {
          _in: useRuntimeConfig().public.postStatus
        }
      },
      fields
    },
  })
)

// Reactive so it tracks the refetched data on navigation (was a one-shot data.value[0]).
const page = computed(() => data.value?.[0])

const seo = computed(() => {
  if (page.value) {
    return useSeo(page.value?.seo, route.fullPath)
  }
  return {}
})

useHead(seo)

const getSectionComponent = key => {
  return contentSections[key]
}
</script>